import { motion } from "framer-motion";
import Seo from "@/lib/Seo";
import PageHero from "@/components/common/PageHero";
import Icon from "@/components/common/Icon";
import { Button } from "@/components/ui/button";
import { easeOut } from "@/components/common/Reveal";
import { FINANCEMENTS } from "@/data/site";
import { useLead } from "@/components/common/LeadModal";

export default function Financements() {
  const { openLead } = useLead();
  return (
    <>
      <Seo
        title="Financements CPF, France Travail, OPCO"
        description="Financez votre formation transport avec EDUCASER GROUP : CPF, France Travail, OPCO, financement entreprise et autres dispositifs. Un accompagnement personnalisé pour optimiser votre budget."
        path="/financements"
      />
      <PageHero
        breadcrumb={[{ label: "Accueil", to: "/" }, { label: "Financements" }]}
        eyebrow="Financer votre formation"
        title="Des solutions de financement adaptées"
        intro="CPF, France Travail, OPCO, entreprise… Nos équipes vous accompagnent pour trouver le dispositif le plus adapté à votre situation."
      />

      <div className="bg-white py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {FINANCEMENTS.map((f, i) => (
              <motion.div
                key={f.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, ease: easeOut, delay: (i % 3) * 0.08 }}
                className={`group rounded-2xl border border-slate-200 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_48px_rgba(0,35,102,0.12)] ${
                  f.id === "autres" ? "md:col-span-2 lg:col-span-1" : ""
                }`}
                data-testid={`financement-${f.id}`}
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-red/10 text-brand-red transition-colors group-hover:bg-brand-red group-hover:text-white">
                  <Icon name={f.icon} className="h-6 w-6" />
                </div>
                <span className="mt-5 inline-block text-xs font-semibold uppercase tracking-wider text-brand-red">
                  {f.nom}
                </span>
                <h3 className="mt-1 font-display text-xl font-bold text-brand-blue">{f.titre}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-500">{f.text}</p>
              </motion.div>
            ))}
          </div>

          <div className="mt-16 overflow-hidden rounded-3xl bg-brand-blue px-8 py-12 text-center sm:px-14">
            <h2 className="font-display text-2xl font-bold text-white sm:text-3xl">
              Besoin d'aide pour financer votre formation ?
            </h2>
            <p className="mx-auto mt-3 max-w-2xl text-white/70">
              Contactez nos équipes qui pourront vous établir un devis et vous accompagner dans
              l'optimisation de votre budget avec les différents types de financement auxquels vous
              pouvez prétendre.
            </p>
            <div className="mt-7 flex flex-wrap justify-center gap-3">
              <Button
                onClick={() => openLead("devis")}
                className="rounded-full bg-brand-red px-7 py-6 text-base font-semibold hover:bg-brand-red-light"
                data-testid="financements-cta-devis"
              >
                Demander un devis
              </Button>
              <Button
                onClick={() => openLead("rappel")}
                variant="outline"
                className="rounded-full border-2 border-white bg-transparent px-7 py-6 text-base font-semibold text-white hover:bg-white hover:text-brand-blue"
                data-testid="financements-cta-rappel"
              >
                Être rappelé
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
